import { Heading } from 'components/v2/Typography/Heading';
import styled from 'styled-components';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 32px 32px 0 32px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: flex-start;
  max-width: 500px;
`;

export const Main = styled.main`
  @media ${({ theme }) => theme.queries.minLargeDesktop} {
  }
  flex: 1 0 auto;
`;

export const Description = styled(Heading).attrs({ tag: 'div', styledAs: 'h5' })`
  padding: 0;
`;
